import api from './api';
import publicApi from './public-api';
import { FormResponse, SendInviteResponse } from '@/types';

const rootPath = '/responses';

export default {
  create: (id: string, response: Partial<FormResponse>): Promise<SendInviteResponse> => {
    return api.post(`${rootPath}/${id}`, response).then(({ data }) => data);
  },

  get: (id: string): Promise<FormResponse> => {
    return publicApi.get(`${rootPath}/${id}`).then(({ data }) => data);
  },

  getList: async (surveyId: string): Promise<FormResponse[]> => {
    return api.get(`${rootPath}/export/${surveyId}`).then(({ data }) => data);
  },

  getAll: async (surveyId: string): Promise<FormResponse[]> => {
    return api.get(`${rootPath}/all/${surveyId}`).then(({ data }) => data);
  },

  getPublicList: async (shareGuid: string): Promise<FormResponse[]> => {
    return publicApi.get(`${rootPath}/export/shared/${shareGuid}`).then(({ data }) => data);
  },

  update: async (response: FormResponse): Promise<FormResponse> => {
    return publicApi.put(`${rootPath}/${response.id}`, response).then(({ data }) => data);
  },

  updateMany: async (responses: FormResponse[]): Promise<FormResponse[]> => {
    return api.put(`${rootPath}`, responses).then(({ data }) => data);
  }
};
